// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { assetsApi } from '@shared/data-access/api/ai/assets-api';
import { appStore as store } from '@advisor-app/store/store';
import {
  groupPositionsByAssetType,
  type InvestmentAssetType,
} from '@shared/data-access/transformers/assets/group-positions-by-asset-type';

/**
 * Classifies a portfolio based on the given tickers.
 *
 * @param tickers - An array of tickers representing the portfolio.
 * @returns A Promise that resolves to the InvestmentAssetType of the portfolio.
 */
export const classifyPortfolio = async (
  tickers: string[],
): Promise<InvestmentAssetType> => {
  const response = await store
    .dispatch(assetsApi.endpoints.classifier.initiate({ payload: tickers }))
    .unwrap();

  const assetsByAssetType = groupPositionsByAssetType(response);
  const types = Object.keys(assetsByAssetType).filter(
    (type: string) =>
      assetsByAssetType[type as keyof typeof assetsByAssetType].length > 0,
  );
  return types.length === 1 ? (types[0] as InvestmentAssetType) : 'other';
};
